var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67064 13.4226L14.2079 6.60439C15.3862 5.42699 15.6783 3.62738 14.9327 2.1378C14.3766 1.0259 13.3199 0.249075 12.0927 0.0499725C10.8656 -0.14913 9.6175 0.253762 8.73837 1.1328L7.67064 2.19985L6.60292 1.1328C5.72378 0.253762 4.47571 -0.14913 3.24854 0.0499725C2.02138 0.249075 0.964707 1.0259 0.408597 2.1378C-0.335926 3.62674 -0.0442648 5.42504 1.13269 6.60235L7.67064 13.4226Z",
    fill: "url(#paint0_linear_12012_163784)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12012_163784",
    x1: 0.0000930029,
    y1: 4.76062e-7,
    x2: 14.6864,
    y2: 14.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8647AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#2F1142"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.219d1934d0b7b25d516deddc2764c2af.svg";
export { ForwardRef as ReactComponent };